import { args } from '../../../common/args';
export const onPrimaryTabChange = {
  onPrimaryTabChange: {
    args: {
      isPrimaryTab: args.bool()
    }
  }
};